// extracted by mini-css-extract-plugin
module.exports = {"NewsItem":"NewsItem_NewsItem__1Fs7g","NewsItemHeader":"NewsItem_NewsItemHeader__25tlE"};